export function validateDateBeforeToday(date?: string): boolean {
  if (!date) return false
  const [day, month, year] = date.split('/').map(Number)
  const inputDate = new Date(year, month - 1, day, 0, 0, 0, 0)
  const today = new Date()
  today.setHours(0, 0, 0, 0)
  return !(inputDate > today)
}
